import type { IMultiselectOption } from '~/types'

export const depositOperations: IMultiselectOption[] = [
  {
    id: 1,
    label: 'widget.deposits.list_meili_search.operations_replenishment',
    value: 'option_replenishment'
  },
  {
    id: 2,
    label: 'widget.deposits.list_meili_search.operations_partial_withdrawal',
    value: 'option_partial_withdrawal'
  },
  {
    id: 3,
    label: 'widget.deposits.list_meili_search.operations_preferential_termination',
    value: 'option_preferential_termination'
  }
]

export const percentPayments: IMultiselectOption[] = [
  { id: 1, label: 'widget.deposits.list_meili_search.payments_monthly', value: 'monthly' },
  { id: 2, label: 'widget.deposits.list_meili_search.payments_end_of_term', value: 'end_of_term' },
  {
    id: 3,
    label: 'widget.deposits.list_meili_search.payments_progressive_accrual',
    value: 'progressive_accrual'
  }
]

export default {
  depositOperations,
  percentPayments
}
